import fetchPosts from "common/fetch/fetchPosts";
import fetchSeo from "common/fetch/fetchSeo";

import Layout from "components/common/Layout";
import CorporateSecretary from "components/templates/hk/corporate-secretary";

import dataCompany from "./data";

export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="hk" page={data?.page}>
        <CorporateSecretary data={data} dataJson={dataCompany} />
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const locale = "hk";
  const uri = "/company-secretary";
  const page = await fetchSeo({
    uri,
    locale,
  });

  const posts = await fetchPosts({
    postPerPage: 20,
    gqlNode: `
        date
        categories {
          nodes {
            name
            uri
            parent {
              node {
                id
              }
            }
          }
        }`,
    locale,
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: posts.nodes || [],
      },
      revalidate: 1,
    },
  };
};
